import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { EditorialMarquee } from "@/components/site/Marquee";
import { OurWork } from "@/components/site/OurWork";
import { Campaigns } from "@/components/site/Campaigns";
import { GetInvolved } from "@/components/site/GetInvolved";
import { Officers } from "@/components/site/Officers";
import { Footer } from "@/components/site/Footer";
import { DonatePopup } from "@/components/site/DonatePopup";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    let raf;
    function loop(time) {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    }
    raf = requestAnimationFrame(loop);

    // anchor links → lenis scroll
    const handler = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80 });
        }
      }
    };
    document.addEventListener("click", handler);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", handler);
    };
  }, []);

  return (
    <div className="grain relative bg-[#FDFBF7]">
      <Navbar />
      <DonatePopup />
      <main>
        <Hero />
        <About />
        <EditorialMarquee />
        <OurWork />
        <Campaigns />
        <GetInvolved />
        <Officers />
      </main>
      <Footer />
    </div>
  );
}
